import { useEffect } from 'react';
import { Form, Modal } from 'antd';
import { useCompleteInquiryMutation } from '@/services/parent-api';
import { useGetInquiryCompletedReasonsQuery } from '@/services/general-api';
import Select from '@/components/select';

const CompleteModal = ({ selectedParentInquiryId, refetch, onClose }) => {
  const { data: reasonData, isLoading: loadingReasonData } = useGetInquiryCompletedReasonsQuery();
  const [completeInquiry, { isLoading: saving }] = useCompleteInquiryMutation();
  const [form] = Form.useForm();

  useEffect(() => {
    if (selectedParentInquiryId) {
      setTimeout(() => {
        form.resetFields();
      });
    }
  }, [selectedParentInquiryId, form]);

  const onFinish = async ({ reasonId }) => {
    try {
      await completeInquiry({
        parentId: selectedParentInquiryId.parentId,
        inquiryId: selectedParentInquiryId.inquiryId,
        reasonId,
      }).unwrap();

      refetch();
      onClose();
    } catch (err) {}
  };

  return (
    <Modal
      title="Complete inquiry"
      open={!!selectedParentInquiryId}
      confirmLoading={saving}
      onOk={() => form.submit()}
      onCancel={onClose}
    >
      <Form layout="vertical" form={form} onFinish={onFinish}>
        <Form.Item name="reasonId" label="Reason" rules={[{ required: true }]}>
          <Select options={reasonData} loading={loadingReasonData} showSearch />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CompleteModal;
